module.exports = __webpack_public_path__ + "img/manejo-capa.467abdb2.webp";